import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=4641c255&"
import script from "./BaseTextarea.vue?vue&type=script&lang=js&"
export * from "./BaseTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4641c255')) {
      api.createRecord('4641c255', component.options)
    } else {
      api.reload('4641c255', component.options)
    }
    module.hot.accept("./BaseTextarea.vue?vue&type=template&id=4641c255&", function () {
      api.rerender('4641c255', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/BaseTextarea.vue"
export default component.exports